<template>
	<div class="wrapper">
		<b-container>
            <detail :mainTit="{'topTxt': article.title, 'date': article.createTime.split(' ')[0] }" :article="article.content">
                <template v-slot:right-related>
                    <detail-related  :title="$t('lang.LatestNews')" :dataList="noticeList"></detail-related>
                    <detail-related v-if="videoList.length > 0"
                         :sort="$route.query.mode"
                         type="video" 
                        :title="$t('lang.RelatedVideo')" 
                        :dataList="videoList"></detail-related>
                </template>
            </detail>
            <Share></Share>
		</b-container>
	</div>
</template>
<script>
import Share from '@/components/share.vue'
import detail from '@/components/detail.vue'
import detailRelated from '@/components/detailRelated.vue'
export default {
    components:{
        detail, detailRelated, Share
    },
    
	data() {
		return {
            mode: '',
			article: {
				// title: '2020未来科学大奖举行云端颁奖典礼 | 科学之光 温暖世界',
				// date: '2021-3-26',
				// content:''
            },
             noticeList:[
                // {
                //     tit: '2020未来科学大奖举行云端颁奖典礼 | 科学之光 温暖世界',
                // },
                // {
                //     tit: '2020未来科学大奖举行云端颁奖典礼 | 科学之光 温暖世界',
                // }
            ],
            videoList: []
		}
    },
    created(){
        this.mode = this.$route.query.mode;
        if(this.mode == 'notice'){
            this.getNoticeInfo(this.$route.query.id);
            this.getNoticeRelatedVideo(this.$route.query.id, 3)
        }else if(this.mode == 'news'){
            this.getNewsInfo(this.$route.query.id);
            this.getNoticeRelatedVideo(this.$route.query.id, 1)
        }else if(this.mode == 'activity'){
            this.getActivityDetail(this.$route.query.id)
            this.getNoticeRelatedVideo( this.$route.query.id, 2, this.$route.query.categoryId )
        }else if(this.mode == 'donorVideo'){
            this.getRelatedVideoInfo(this.$route.query.id)
            this.getDonorRelated( this.$route.query.dornorID, this.$route.query.id)
        }
        this.getNewsList();
    },
    methods:{
        getNoticeRelatedVideo(id, type, categoryId){
            this.$api.noticeRelatedVideo({
                id: id,
                type: type,
                categoryId: categoryId
            }).then(res=>{
                this.videoList = res.data
            })
        },
        getRelatedVideoInfo(id){
            this.$api.videoDetail({
                id: id
            }).then(res=>{
                this.article = res.data
            })
        },
        getDonorRelated(donorId, id){
            this.$api.detailRelatedVideo({
                 donorId: donorId,
                 id: id,
                 page: 1,
                 limit: 20
            }).then(res=>{
                this.videoList = res.data.records
            })
        },
        getActivityDetail(id){
            this.$api.activityDetail({
                id: id
            }).then(res=>{
                 this.article = res.data
            })
        },
        getRelatedVideo(categoryId, id){
            this.$api.relatedVideo({
                categoryId: categoryId ? categoryId: '',
                id: id
            }).then(res=>{
                this.videoList = res.data
            })
        },
        getNewsList(){
            this.$api.newsList({
                page: 1,
                limit: 5
            }).then(res=>{
                this.noticeList = res.data.records;
            })
        },
        getNoticeInfo(id){
            this.$api.noticeInfo({id: id})
            .then(res=>{
                this.article = res.data;
            })
        },
        getNewsInfo(id){
            this.$api.newsInfo({id: id})
            .then(res=>{
                this.article = res.data;
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.wrapper{
    min-height: 80rem;
}
img {
	width: 100% !important;
}
.title {
	font-size: 1.6rem;
	color: #333333;
	text-align: left;
	padding: 0 2rem;
	margin-top: 2rem;
}
.time-info {
	font-size: 1rem;
	color: #666666;
	text-align: left;
	margin-top: 2rem;
	padding-left: 2rem;
}
.content {
	padding: 0 2rem;
	margin-top: 2rem;
	line-height: 2.2rem;
    // height: 500px;
}
.right {
	padding: 2rem;
	.right-item {
		font-size: 1rem;
		color: #666666;
		line-height: 1.8rem;
		padding: 0.2rem;
		border-bottom: 0.1rem solid #ebebeb;
	}
	.right-item:hover {
		color: #caa151;
		cursor: pointer;
	}
}
</style>
